import React, { useEffect, useState } from 'react';
import { dateReadableFormat } from '../../common/dateTimeFuncs';
import { landingPageRoute } from '../../common/linkRoutes';
import DateNavigator from '../../components/dateNavigator/DateNavigator';
import Goal from '../../components/goal/Goal';
import Layout from '../../components/layout/Layout';
import Task from '../../components/task/Task';
import { getLatestUnComTasksFromList } from '../../components/task/taskFuncs';
import { getListByParentKey } from '../../firebase/refActions';
import { goalRef, taskRef } from '../../firebase/refs';
import { DailyTaskI } from '../../interfaces/DailyTaskInterface';
import { GoalI } from '../../interfaces/GoalInterface';
import { useStore } from '../../store/store';
import { BasicProps } from '../goals/GoalPage';

const TasksPage = (props: BasicProps) => {
  const { user } = useStore();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [taskList, setTaskList] = useState<DailyTaskI[]>([]);
  const [goalList, setGoalList] = useState<GoalI[]>([]);
  const [completeTask, setCompleteTask] = useState<number>(0);

  useEffect(() => {
    if (!user) return;
    var _isSubscribe = true;

    getListByParentKey(
      goalRef,
      user.uid,
      'user_uid',
      (res: { data: GoalI[]; error: any }) => {
        if (res.data && _isSubscribe) {
          setGoalList(res.data);
        }
      }
    );

    return () => {
      _isSubscribe = false;
    };
  }, [selectedDate, user, completeTask]);

  useEffect(() => {
    if (!user) return;
    var _isSubscribe = true;
    var list: DailyTaskI[] = [];

    if (_isSubscribe) {
      getListByParentKey(
        taskRef,
        user.uid,
        'user_uid',
        (res: { data: DailyTaskI[]; error: any }) => {
          if (res.data) {
            list = getLatestUnComTasksFromList(
              res.data,
              selectedDate,
              user,
              null,
              null
            );

            if (_isSubscribe) {
              setTaskList(list);
            }
          }
        }
      );
    }

    return () => {
      taskRef.off();
      goalRef.off();
      _isSubscribe = false;
    };
  }, [selectedDate, user, completeTask]);

  return (
    <Layout pageName="Daily Tasks" backRoute={landingPageRoute} {...props}>
      <DateNavigator
        onBack={() =>
          setSelectedDate(
            new Date(selectedDate.setDate(selectedDate.getDate() - 1))
          )
        }
        onToday={() => setSelectedDate(new Date())}
        onForward={() =>
          setSelectedDate(
            new Date(selectedDate.setDate(selectedDate.getDate() + 1))
          )
        }
      />
      <br />
      <h2 style={{ marginRight: 'auto' }}>
        {dateReadableFormat(selectedDate)}
      </h2>

      {React.Children.toArray(
        taskList.map((_t) => {
          const taskGoal = goalList
            .filter((_task) => _task.user_uid === user?.uid)
            .find((g) => g.key === _t.goal_key);

          return (
            <Goal
              data={taskGoal}
              task={
                <Task
                  data={_t}
                  onDone={() => setCompleteTask(completeTask + 1)}
                />
              }
            />
          );
        })
      )}
    </Layout>
  );
};

export default TasksPage;
